<div class="container">
  <h2>New Mentor Contact Log</h2>
  <form [formGroup]="mainForm" (ngSubmit)="addMentorContact()" novalidate>
    <mat-dialog-content>
      <div fxLayout="column" fxLayoutAlign="space-around start" fxFill>
        <mat-form-field class="narrow-field">
          <mat-label>Mentor</mat-label>
          <input matInput formControlName="mentorName">
        </mat-form-field>

        <mat-form-field class="narrow-field">
          <mat-label>Contacted By</mat-label>
          <input matInput formControlName="contactedBy">
        </mat-form-field>

        <mat-form-field class="narrow-field">
          <mat-label>Communication Method</mat-label>
          <mat-select formControlName="communicationType" required>
            <mat-option [value]="1">Email</mat-option>
            <mat-option [value]="2">Phone</mat-option>
          </mat-select>
          @if (this.mainForm.controls['communicationType'].hasError('required')) {
            <mat-error>
              This field is required
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="narrow-field">
          <input [max]="today"  matInput [matDatepicker]="contactDate" placeholder="Contact Date" formControlName="contactDate">
          <mat-datepicker-toggle matSuffix [for]="contactDate"></mat-datepicker-toggle>
          <mat-datepicker #contactDate></mat-datepicker>
          @if (this.mainForm.controls['contactDate'].hasError('matDatepickerMax')) {
            <mat-error>
              Date cannot be in the future
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Note</mat-label>
          <textarea matInput formControlName="note" required rows="5"></textarea>
          @if (this.mainForm.controls['note'].hasError('required')) {
            <mat-error>
              This field is required
            </mat-error>
          }
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button id="saveButton" type="submit" [disabled]="addingInProgress === true" mat-button color="primary" mat-button mat-raised-button>
        Save
      </button>
      <button mat-button mat-dialog-close color="warn" mat-button mat-raised-button>
        Cancel
      </button>
      @if (addingInProgress === true) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </mat-dialog-actions>
  </form>
</div>